import { closeRegoLookup } from '../../_flux/actions/rego_lookup_actions';

export function onClose() {
    closeRegoLookup();
}
